import type { PublicIncidentSummary } from "@/v2-status-client/status/status.types"
import { formatDurationMinutes } from "@/v2-status-client/status/status.utils"
import StatusIncidentBadge from "@/v2-status-client/status/incident/StatusIncidentBadge"

export type StatusIncidentRowProps = {
  incident: PublicIncidentSummary
}

// One row inside an incident day group: state badge + title +
// "Affected: X · 14 minutes" meta. Customer vocabulary throughout;
// no error messages, HTTP codes, or per-target lists -- those live
// in the operator dashboard.
function StatusIncidentRow(props: Readonly<StatusIncidentRowProps>) {
  const { incident } = props
  return (
    <li className="flex items-start gap-3 py-2">
      <div className="pt-0.5 shrink-0">
        <StatusIncidentBadge state={incident.state} />
      </div>
      <div className="flex flex-col gap-0.5 min-w-0">
        <div className="text-sm text-foreground">{incident.title}</div>
        <div className="text-xs text-muted-foreground">
          Affected: {incident.affectedScope}
          {incident.durationMinutes > 0 && (
            <> · {formatDurationMinutes(incident.durationMinutes)}</>
          )}
        </div>
      </div>
    </li>
  )
}

export default StatusIncidentRow
